// extracted by mini-css-extract-plugin
export default {"report-wrapper":"style_report-wrapper__5zSdf"};